import { Injectable } from '@angular/core';
import { UserProfileRecord } from 'app/users/user-profile-record';
import { UserService } from 'app/users/user.service';

@Injectable({
  providedIn: 'root'
})
export class AppInfoService {
  token: any;
  constructor(
    private userService: UserService,
  ) {

      const queryString = window.location.search;
      if (queryString) {
        var urlParams = new URLSearchParams(queryString);
        this.token = urlParams.get('token');
        this.userService.setProfile (this.buildUserProfile(urlParams));
      }
   }

   buildUserProfile(urlParams): UserProfileRecord {
    let availableRoles: string[] = this.buildAvailableRoles(urlParams);
    return {
      groups: urlParams.get('groups'),
      uniqueId: urlParams.get('ssoId'),
      email: urlParams.get('email'),
      displayName: urlParams.get('fullName'),
      firstName: urlParams.get('firstName'),
      lastName: urlParams.get('lastName'),
      orgId: urlParams.get('orgId'),
      availableRoles: availableRoles,
      userRole: this.setUserRole(availableRoles)
    }
  }

  buildAvailableRoles(urlParams): string[] {
    let roleNames: string = urlParams.get('userRole');
    let groupNames: string = urlParams.get('groups');
    let roleNamesArray: string[] = [];

    if(roleNames) {
      roleNamesArray = roleNames.split(',');
    }
    
    if(groupNames?.includes('USANAMAAdmin')) {
      roleNamesArray.push('USAN AMA Admin');
    }

    return roleNamesArray;
  }

  setUserRole(availableRoles: string[]): string | undefined {
    if(availableRoles && availableRoles.length === 1) {
      return availableRoles[0];
    }

    return undefined;
  }
}
